import { makeStyles } from '@fluentui/react-components';
import * as React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import WindowsIcon from '../../../content/images/WindowsIcon.svg';

interface ProductImageProps {}

const messages = defineMessages({
    imageAlt: {
        id: 'WindowsProductImage_Image_Alt',
        defaultMessage: 'Windows Dev Box',
        description: 'Alt text for product image',
    },
});

/**
 * Styles
 */

const useStyles = makeStyles({
    root: {
        height: '20px',
        width: '20px',
    },
});

/**
 * END Styles
 */

export const WindowsProductImage: React.FC<ProductImageProps> = React.memo(() => {
    // Intl hooks
    const { formatMessage } = useIntl();

    // Style hooks
    const styles = useStyles();

    return <img alt={formatMessage(messages.imageAlt)} className={styles.root} src={WindowsIcon} />;
});

export default WindowsProductImage;
